export const showMonetateTests = {
  showDeliveryEstimates: true,
  showDeliveryEstimatesNextDay: true,
  showDeliveryEstimatesStandard: true,
  app20Off: false
};
